import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { MatDialogClose, MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { LOGOUT_COUNTDOWN_PERIOD } from "src/app-legacy/core/constants/constants";
import { AuthService } from "src/app-legacy/core/services/auth.service";

@Component({
	selector: "app-inactivity-modal",
	imports: [CommonModule, MatDialogContent, MatDialogClose],
	templateUrl: "./inactivity-modal.component.html",
})
export class InactivityModalComponent implements OnInit, OnDestroy {
	dialogRef = inject(MatDialogRef);
	private _auth = inject(AuthService);

	logoutCountDownTime = LOGOUT_COUNTDOWN_PERIOD;

	countdownInterval?: ReturnType<typeof setInterval>;

	get remainingMinutes(): number {
		return Math.floor(this.logoutCountDownTime / 60);
	}

	get remainingSeconds(): number {
		return this.logoutCountDownTime % 60;
	}

	ngOnInit(): void {
		this.startCountDown();
	}

	ngOnDestroy(): void {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
	}

	/**
	 * Starts the countdown to logging out the user
	 */
	startCountDown(): void {
		this.countdownInterval = setInterval(() => {
			this.countDown();
		}, 1000);
	}

	/**
	 * Reduces remaining countdown time and logs out the user if it reaches 0
	 */
	countDown(): void {
		this.logoutCountDownTime--;

		if (this.logoutCountDownTime === 0) {
			this.logout();
		}
	}

	logout(): void {
		this._auth.timeOutLogout();
		this.dialogRef.close();
	}
}
